'use strict';

import { service } from '@/plugins/feathers-client';
import * as actions from './actions';


export default service('users', {
	actions,
});
